module.exports = __webpack_public_path__ + "static/SpaceMono-Regular-8219a6a1194ea5dbef06c9182abd3b6f.ttf";